var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "lexon-dropdown-list-options" },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.listOptions,
            expression: "listOptions",
          },
        ],
        ref: "hiddenInput",
        staticClass: "hidden-input",
        domProps: { value: _vm.listOptions },
        on: {
          focus: _vm.emitComponentValue,
          input: function ($event) {
            if ($event.target.composing) return
            _vm.listOptions = $event.target.value
          },
        },
      }),
      _c(
        "transition-group",
        {
          staticClass: "transition-div",
          attrs: { name: "reorder-transition", tag: "div" },
        },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "div",
            { key: item.uuid, staticClass: "option" },
            [
              _c("LexonTextFieldComponent", {
                ref: `option-${index}`,
                refInFor: true,
                staticClass: "textfield",
                attrs: {
                  id: `option-${index}`,
                  name: `option-${index}`,
                  label: _vm.texts.optionLabel,
                  validationRules:
                    index === 0 && !_vm.items[0].value ? "required" : "",
                },
                on: {
                  blur: function ($event) {
                    return _vm.addFieldValueToListOptions($event, index)
                  },
                },
                model: {
                  value: item.value,
                  callback: function ($$v) {
                    _vm.$set(item, "value", $$v)
                  },
                  expression: "item.value",
                },
              }),
              _c("div", { staticClass: "actions-container" }, [
                _c("button", {
                  class: [
                    _vm.icons.arrowDown,
                    "arrow",
                    { disabled: index + 1 >= _vm.items.length },
                  ],
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      index + 1 >= _vm.items.length
                        ? false
                        : _vm.move(index, _vm.movementDirection.down)
                    },
                  },
                }),
                _c("button", {
                  class: [
                    _vm.icons.arrowUp,
                    "arrow",
                    { disabled: index === 0 },
                  ],
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      index === 0
                        ? false
                        : _vm.move(index, _vm.movementDirection.up)
                    },
                  },
                }),
                _c("button", {
                  class: [
                    _vm.icons.remove,
                    { disabled: _vm.items.length <= _vm.defaultVisibleFields },
                  ],
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.removeField(index)
                    },
                  },
                }),
              ]),
            ],
            1
          )
        }),
        0
      ),
      _c("div", { staticClass: "add-new-option-container" }, [
        _c("p", { staticClass: "add-new-option-text" }, [
          _vm._v(_vm._s(_vm.texts.addNewOption)),
        ]),
        _c("button", {
          class: [
            _vm.icons.add,
            "round-btn",
            { disabled: _vm.disabledAddOptionButton },
          ],
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.addNewOption.apply(null, arguments)
            },
          },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }